
import { useAuth } from "../contexts/AuthContext";
import Login from "./Login";
import Dashboard from "./Dashboard";

const AppRouter = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return <Dashboard />;
};

export default AppRouter;
